import { render, staticRenderFns } from "./instruction_en.vue?vue&type=template&id=7b0b8c2b&scoped=true"
import script from "./instruction_en.vue?vue&type=script&lang=js"
export * from "./instruction_en.vue?vue&type=script&lang=js"
import style0 from "./instruction_en.vue?vue&type=style&index=0&id=7b0b8c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0b8c2b",
  null
  
)

export default component.exports